import * as React from "react";
import { connect } from "react-redux";
import { CoopConstants } from "../../../constants/CoopConstants";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopProjectTypeInfo, selectCoopSelectedProjectDifficultyLevel, } from "../../../selectors/selectCoopInfo";
import { selectCoopProjectInfo } from "../../../selectors/selectCoopProjectInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilCoopProject } from "../../../utils/utilCoopProject";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionCoopProjectDifficultySelected } from "../actionCoop";
import { CoopProjectInformationHeader } from "./CoopProjectInformationHeader";
import { CoopProjectRequiredResource } from "./CoopProjectRequiredResource";
import { DifficultyLevelSelection } from "./DifficultyLevelSelection";
var _CoopProjectInformation = function (_a) {
    var coopProject = _a.coopProject, activeCoopProject = _a.activeCoopProject, projectTypeInfo = _a.projectTypeInfo, selectedCoopProjectDifficultyLevel = _a.selectedCoopProjectDifficultyLevel, onSelectProjectDifficulty = _a.onSelectProjectDifficulty;
    var difficultyLevelMaxSelectable = getMaxSelectableDifficultyLevel(coopProject, projectTypeInfo);
    var difficultyLevel = 1;
    if (activeCoopProject &&
        activeCoopProject.difficulty &&
        activeCoopProject.projectId &&
        coopProject.id === activeCoopProject.typeId) {
        difficultyLevel = activeCoopProject.difficulty;
    }
    else if (selectedCoopProjectDifficultyLevel > -1) {
        difficultyLevel =
            selectedCoopProjectDifficultyLevel <= difficultyLevelMaxSelectable
                ? selectedCoopProjectDifficultyLevel
                : difficultyLevelMaxSelectable;
    }
    var requiredResourceElements = getRequiredResources(coopProject, selectedCoopProjectDifficultyLevel);
    var enabled = activeCoopProject == undefined ||
        activeCoopProject.projectId === undefined ||
        coopProject.id !== activeCoopProject.typeId;
    return (React.createElement("div", null,
        React.createElement(CoopProjectInformationHeader, { coopProject: coopProject }),
        React.createElement(DifficultyLevelSelection, { difficultyLevel: difficultyLevel, difficultyLevelMax: CoopConstants.DifficultyLevelMax, difficultyLevelMaxReachable: coopProject.difficultyLevel.length, difficultyLevelMaxSelectable: difficultyLevelMaxSelectable, isEnabled: enabled, onDifficultyClick: function (index) {
                return onDifficultyClick(index, coopProject, onSelectProjectDifficulty);
            } }),
        React.createElement("div", { className: IdStyles.InventoryBuyContainerCost + " coop-projects__requirements-container" },
            React.createElement(TextLoca, { id: IdLoca.collectForMany, className: IdStyles.TextBoldPrimary }),
            React.createElement("div", { className: "flex flex--around" }, requiredResourceElements))));
};
var getMaxSelectableDifficultyLevel = function (selectedCoopProject, projectTypeInfo) {
    var coopProjectTypeParam;
    if (selectedCoopProject && projectTypeInfo) {
        coopProjectTypeParam = projectTypeInfo.find(function (value) { return value.typeId === selectedCoopProject.id; });
    }
    return coopProjectTypeParam && coopProjectTypeParam.maxDifficulty
        ? coopProjectTypeParam.maxDifficulty
        : 1;
};
var getRequiredResources = function (selectedCoopProject, selectedCoopProjectDifficultyLevel) {
    var requiredResources = selectedCoopProject.difficultyLevel.find(function (difficultyLevel) { return difficultyLevel.level === selectedCoopProjectDifficultyLevel; }).requiredRes;
    return requiredResources
        ? requiredResources.map(function (requiredResource) {
            return (React.createElement(CoopProjectRequiredResource, { key: "required-resource_" + requiredResource.resourceId, requiredResource: requiredResource }));
        })
        : undefined;
};
var onDifficultyClick = function (index, coopProject, onSelectProjectDifficulty) {
    var selectedProjectDifficulty = utilCoopProject.getProjectDifficultyLevelType(coopProject, index);
    if (selectedProjectDifficulty) {
        onSelectProjectDifficulty(selectedProjectDifficulty);
    }
};
var mapState = function (state) {
    return {
        activeCoopProject: selectCoopProjectInfo(state),
        projectTypeInfo: selectCoopProjectTypeInfo(state),
        selectedCoopProjectDifficultyLevel: selectCoopSelectedProjectDifficultyLevel(state),
    };
};
var mapDispatch = function (dispatch) {
    return {
        onSelectProjectDifficulty: function (projectDiffculty) {
            return dispatch(actionCoopProjectDifficultySelected(projectDiffculty.level));
        },
    };
};
export var CoopProjectInformation = connect(mapState, mapDispatch)(_CoopProjectInformation);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/CoopProjectInformation.tsx
// module id = 2590
// module chunks = 3